import React from 'react'
import { useIntl } from 'react-intl'

import styled from 'styled-components/macro'

import ButtonFederatedLogin from 'Components/ButtonFederatedLogin'
import IconSVG from 'Components/IconSVG'
import TextDiviser from 'Components/TextDiviser'

import { EmailLinkS, RootS, WrapperInnerS } from './ListButtonFederatedLogin.styled'

type FederatedPlatform = 'google' | 'microsoft' | 'facebook' | 'amazon' | 'ping'

const DEFAULT_PLATFORMS: FederatedPlatform[] = ['google', 'microsoft', 'facebook', 'amazon', 'ping']

interface ListButtonFederatedLoginPropsI {
  isSignUp?: boolean;
  isMigration?: boolean;
  className?: string;
  hasOr?: boolean;
  messageOrOnStart?: boolean;
  color?: string;
  slug?: string | null;
  isAdmin?: boolean;
  only?: string | null;
  invite?: string;
  showMinimal?: boolean;
  pricePreChosen?: string | null;
  email?: string;
  showEmail?: boolean;
  onClickEmail?: () => void;
  priority?: FederatedPlatform | null;
}

const ListButtonFederatedLogin = (props: ListButtonFederatedLoginPropsI) => {
  const {
    isSignUp = false,
    isMigration = false,
    className,
    slug,
    color,
    hasOr,
    isAdmin = false,
    invite,
    messageOrOnStart = true,
    showMinimal = false,
    only,
    email,
    showEmail = false,
    onClickEmail,
    priority
  } = props
  const intl = useIntl()
  const contentOr = hasOr ? (
    <TextDiviser>{intl.formatMessage({ id: 'ou' })}</TextDiviser>
  ) : null

  const hasPriority = !!priority && DEFAULT_PLATFORMS.includes(priority) && !showMinimal
  const allowedPlatforms = DEFAULT_PLATFORMS.filter(p => p !== 'ping' || priority === 'ping')
  const restPlatforms = hasPriority
    ? allowedPlatforms.filter(p => p !== priority)
    : allowedPlatforms

  const renderButton = (platform: FederatedPlatform, minimal: boolean) => (
    <ButtonFederatedLogin
      key={platform}
      className={minimal ? 'px-4 py-0' : 'w-100 mt-2'}
      showMinimal={minimal}
      isSignUp={isSignUp}
      isMigration={isMigration}
      platform={platform}
      slug={slug}
      isAdmin={isAdmin}
      color={color}
      invite={invite}
      email={platform === 'ping' ? email : undefined}
    />
  )

  return (
    <RootS className={className}>
      {messageOrOnStart ? contentOr : null}
      {hasPriority && priority && (!only || only === priority)
        ? (
          <WrapperInnerS showMinimal={false}>
            {renderButton(priority, false)}
          </WrapperInnerS>
          )
        : null}
      <WrapperInnerS className={hasPriority ? 'mt-3' : ''} showMinimal={hasPriority || showMinimal}>
        {restPlatforms.map(platform => (
          !only || only === platform ? renderButton(platform, hasPriority || showMinimal) : null
        ))}
      </WrapperInnerS>
      {showEmail
        ? (
          <EmailLinkS type="button" onClick={onClickEmail}>
            <IconSVG icon="email" size="small" />
            {`${intl.formatMessage({ id: 'Logar com' })} ${intl.formatMessage({ id: 'email' })}`}
          </EmailLinkS>
          )
        : null}
      {!messageOrOnStart ? contentOr : null}
    </RootS>
  )
}

export default styled(ListButtonFederatedLogin)``
